import { i18n as i18n$1 } from './translate.js';
i18n$1.loadTranslations();
var i18n = i18n$1;
export { i18n };